module.exports = __webpack_public_path__ + "static/media/letpension-logo.e3a280d6.svg";